import React, {useState, useEffect} from 'react'
import * as THREE from "three";
import { useTexture } from '@react-three/drei';
import { useSelector } from 'react-redux'

import { CodiciColoreOmbrelloni } from '../CodiciColoreOmbrelloni';
import { E_ColoriTessuto } from '../../Utils/enumerations';

// Mesh della grondaia degli ombrelloni
export default function Grondaia( {position, rotation, larghezza, lunghezza} ) {   
    const R =  0.6;
    const r =  R;
    var cx = 0;
    var cy = 0;
    const sAngle = THREE.MathUtils.degToRad(30);
    const eAngle = THREE.MathUtils.degToRad(150);

    const scale = [lunghezza, 1, larghezza];
  
    const coloreTessutoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.coloreTessutoOmbrelloni);   
    
    const fabricTexturesProps = useTexture({
      map: `${process.env.PUBLIC_URL}/textures/grondaia/Fabric_basecolor.jpg`,
      normalMap: `${process.env.PUBLIC_URL}/textures/grondaia/Fabric_normal.jpg`,
      roughnessMap: `${process.env.PUBLIC_URL}/textures/grondaia/Fabric_roughness.jpg`,
      aoMap: `${process.env.PUBLIC_URL}/textures/grondaia/Fabric_ambientOcclusion.jpg`,    
    })
    
    fabricTexturesProps.map.repeat.set(75, 75);
    fabricTexturesProps.normalMap.repeat.set(75, 75);
    fabricTexturesProps.roughnessMap.repeat.set(75, 75);
    fabricTexturesProps.aoMap.repeat.set(75, 75);  
    
    fabricTexturesProps.map.wrapS = fabricTexturesProps.map.wrapT = THREE.RepeatWrapping;
    fabricTexturesProps.normalMap.wrapS = fabricTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
    fabricTexturesProps.roughnessMap.wrapS = fabricTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
    fabricTexturesProps.aoMap.wrapS = fabricTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;
  
    const [fabricColor, setFabricColor] = useState(CodiciColoreOmbrelloni.find(el => el.label.toString() === E_ColoriTessuto.T15.toString()).value);

    useEffect(() => {          
        // Salva il colore del tessuto degli ombrelloni
        let colorCode = CodiciColoreOmbrelloni.find(el => el.label.toString() === coloreTessutoOmbrelloni.toString()).value;
        setFabricColor(colorCode);
    }, [coloreTessutoOmbrelloni]);
   
    let shape = new THREE.Shape();

    shape.absarc(cx, cy, R, sAngle, eAngle);
    shape.absarc(cx, cy, r, eAngle, sAngle, true);

    const extrudeSettings = {
        steps: 2,
        depth: 1,
        bevelEnabled: false,
        bevelThickness: 1,
        bevelSize: 1,
        bevelOffset: 0,
        bevelSegments: 1
    };

    return (
        <mesh position={position} rotation={rotation} scale={scale}>
            <extrudeGeometry args={[shape, extrudeSettings]} />
            <meshStandardMaterial { ...fabricTexturesProps } color={fabricColor} roughness={5}/>             
        </mesh>
    )
}
